import React from "react";
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import Button from "../../../components/buttons/Button";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import InputField from "../../../components/inputFields/InputField";
import { toast } from "react-toastify";
import FormikDropdown from "../../../components/inputFields/FormikDropDown";
import { addHudPatientDoses, updateHudPatientDoses } from "../../../services/hud/hud_doses";

const AddUpdateDose = ({ packageId, onDoseOperation, initialValues }) => {
    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const response = initialValues ? await updateHudPatientDoses(packageId, initialValues.dose_id, values) : await addHudPatientDoses(packageId, values);
            if (initialValues ? response?.status === 200 : response?.status === 201) {
                onDoseOperation();
                toast.success("Dose added successfully!");
            } else {
                toast.error("Oops! Something went wrong, please try again.");
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        j_cm2: Yup.string().required("Energy is required"),
        tube: Yup.string().required("Tube is required"),
    });

    return (
        <>
            <div className="w-full flex-1">
                <StyledHeadingText text={initialValues ? "Update Dose" : "Add Dose"} />
                <Formik
                    initialValues={initialValues || {
                        j_cm2: "",
                        tube: "",
                        date: new Date().toISOString().split("T")[0],
                        note: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, setFieldValue, values }) => (
                        <Form className="space-y-4 my-4">
                            <div className="flex gap-4 flex-col">
                                <div className="grid gap-6 lg:grid-cols-3">
                                    <InputField
                                        label="J/CM²"
                                        name="j_cm2"
                                        type="text"
                                        placeholder="Enter J/CM²"
                                        required
                                    />
                                    <FormikDropdown
                                        label="Tube"
                                        name="tube"
                                        placeholder="Select Tube"
                                        required
                                        options={[
                                            { label: "Tube A", value: "Tube A" },
                                            { label: "Tube B", value: "Tube B" },
                                        ]}
                                    />
                                    <InputField
                                        label="Date"
                                        name="date"
                                        type="date"
                                        placeholder="Select Date"
                                    />
                                </div>
                                <InputField
                                    label="Note"
                                    name="note"
                                    type="text"
                                    placeholder="Enter Quick Note here..."
                                />
                                <Button
                                    type="submit"
                                    className="bg-primary text-white px-4 py-2 rounded max-w-32"
                                    disabled={isSubmitting}
                                >
                                    {initialValues ? "Update" : "Add"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div >
        </>
    );
};

export default AddUpdateDose;
